import { useReveal } from '../hooks/useReveal'

/**
 * RevealDiv (Rv) — wraps any children with a scroll-triggered
 * fade-and-rise reveal animation driven by CSS classes.
 */
export function Rv({ children, tag: Tag = 'div', delay = 0, className = '', style = {} }) {
  const [ref, vis] = useReveal()
  return (
    <Tag
      ref={ref}
      className={`rv${vis ? ' in' : ''} ${className}`}
      style={{ transitionDelay: `${delay}s`, ...style }}
    >
      {children}
    </Tag>
  )
}
